import React from "react";
import classNames from "classnames/bind";
import styles from "../../../components/ProductDetail/ProductDetail.module.scss";
import { IonBadge } from "@ionic/react";
import { activeModule } from "../../../providers/active-module";

const cx = classNames.bind(styles);

interface AttributeBadgeProps {
  value: string;
  onClick?: () => void;
  isDisabled?: boolean;
  isColorPrimary?: boolean;
}

const isActiveModuleCore = activeModule === "PARHATO2";

const AttributeBadge = ({ value, isDisabled = false, isColorPrimary = false, onClick }: AttributeBadgeProps) => {
  return (
    <IonBadge
      className={cx("attributesCardBadge", { disabled: isDisabled })}
      color={isColorPrimary ? (isActiveModuleCore ? "success" : "primary") : "medium"}
      mode="md"
      onClick={onClick}
    >
      <span className="pointer-events-none" style={{ pointerEvents: "none" }}>{value}</span>
    </IonBadge>
  );
};

export { AttributeBadge };
